import { Component, AfterContentInit, ElementRef } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { FilterService } from './filter.service';
import { ConsultService } from './consult.service';
import $ from './lib/jquery';
import UIkit from './lib/uikit';
declare var jivo_api: any;

@Component({
  selector: 'left-menu',
  templateUrl: '../templates/left-menu.component.html',
  styleUrls: ['../styles/components/left-menu.component.less']
})
export class LeftMenuComponent implements AfterContentInit {
  toggleButtons: JQuery;
  backButton: JQuery;
  nextButton: JQuery;
  offcanvases: any[];
  showScrollUp = false;

  constructor(
    public filterService: FilterService,
    public consult: ConsultService,
    private el: ElementRef,
    private router: Router,
  ) {
    if (typeof window !== 'undefined') {
      this.router.events.pipe(
        filter((e: any) => e instanceof NavigationEnd)
        ).subscribe(() => {
          this.offcanvases
            .filter((ofc) => ofc.$el.id !== 'LeftMenu_Item_ConsultWindow')
            .forEach((ofc) => ofc.hide());
        });

      window.addEventListener('scroll', () => this.showScrollUp = window.scrollY > 1000);
    }
  }

  ngAfterContentInit() {
    if (typeof window === 'undefined') return;

    const leftMenu = this.el.nativeElement;
    const $leftMenu = $(leftMenu);
    this.toggleButtons = $leftMenu.find('.LeftMenu_Item--toggleBtn');
    this.backButton = $leftMenu.find('#LeftMenu_BtnPageBack');
	this.nextButton = $leftMenu.find('#LeftMenu_BtnPageNext');
    this.offcanvases = [];

    this.toggleButtons.each((_: number, button: Element) => {
      const target = button.getAttribute('uk-toggle').replace('target: ', '');
      const offcanvas = UIkit.offcanvas(leftMenu.querySelector(target));
      this.offcanvases.push(offcanvas);
      const offcanvasEl = $(offcanvas.$el);

      offcanvasEl
        // add active state to button
        .on('show', (e: JQueryEventObject) => {
          if ((<Node>e.target).isEqualNode(e.delegateTarget)) {
            button.classList.add('LeftMenu_Item--active');
          }
        })
        // remove active state from button
        .on('hide', (e: JQueryEventObject) => {
          if ((<Node>e.target).isEqualNode(e.delegateTarget)) {
            button.classList.remove('LeftMenu_Item--active');
          }
        });

        // Prevent swipe
        if (target !== '#LeftMenu_Item_ConsultWindow') {
          offcanvasEl.find('.LeftMenu_Panel_Content').on('swipeLeft', (e: JQueryEventObject) => {
            e.stopPropagation();
            e.stopImmediatePropagation();
          });
        }

        if (target === '#LeftMenu_Item_ConsultWindow') setTimeout(() => offcanvas.show(), 10000);
    });

    this.backButton.on('click', () => window.history.back());
	
	this.nextButton.on('click', () => window.history.go(1));

	var JivoChat = document.getElementById('JivoChat');
	JivoChat.onclick = function(){
		JivoChat.classList.toggle('LeftMenu_Item--active');
		if(JivoChat.getAttribute('data-jivo')=="close")
		{
			jivo_api.open();
			JivoChat.setAttribute('data-jivo','open');
			var jivo_close_button = document.getElementById('jivo_close_button');
			jivo_close_button.onclick = function(){ 
				jivo_api.close();
				JivoChat.setAttribute('data-jivo', 'close');
				JivoChat.classList.toggle('LeftMenu_Item--active');
			}
		}
		else {
			jivo_api.close();
			JivoChat.setAttribute('data-jivo', 'close');
		}
	}
  }
}

